import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col } from 'react-bootstrap';

import errores from '../../middleware/errordb'
import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';
import TitleModule from '../widgets/module_title';
import BackButton from '../widgets/back_button';

class FormularioUsuario extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('_id');
        this.state = {
            titulo: "Crear Usuarios",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            empresa: currentCompany,
            codEmp: "",
            nombre: "",
            id_usuario: "",
            usuario: "",
            password: "",
            tipo: currentUserType,
            usuario_login: currentUser,
            estado: "1",
            tipo_usuario: "1",
            mensaje: "",
            vendedores: [],
            vendedor_asociado: "0",
            isfacele: false,
            iscatalogo: false,
            isestrutura: false,
            isventas: false,
            ispedido: false,
            isadmpedido: false,
            ispos: false,
            isinventario: false,
            activefacele: true,
            activecatalogo: true,
            activeestrutura: true,
            activeventas: true,
            activepedido: true,
            activeinventario: true,
            activepos: true,
            activeadmpedido: false,
            dinamyc_permit: [],
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_usuario = "";
        const usuarioEdicion = search.replace('?', '');
        const { usuario_login } = this.state;
        const { empresa } = this.state;
        if (usuarioEdicion) {
            titulo = "Modificar Usuarios";
            id_usuario = usuarioEdicion;
        } else {
            titulo = "Crear Usuarios";
            id_usuario = "";
        }
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                id_usuario,
                usuario_login
            }),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/users/', datasend).then(response => response.json())
            .then(data => {
                const datos = data.data;
                const usuario = datos[0];
                const perm = datos[1];
                const vend = datos[2];
                const permitsByCompany = datos[3];

                if (usuario.length > 0) {
                    this.setState({
                        codEmp: usuario[0]["CODIGO_EMPRESA"],
                        nombre: usuario[0]["NOMBRE_COMPLETO"],
                        usuario: usuario[0]["USUARIO"],
                        id_usuario: usuario[0]["ID_USUARIO"],
                        password: usuario[0]["PASSWORD"],
                        estado: usuario[0]["ESTADO"],
                        tipo_usuario: usuario[0]["TIPO_USUARIO"],
                        vendedor_asociado: usuario[0]["VENDEDOR_ASOCIADO"],
                        isfacele: usuario[0]["FACTURACION_ELECTRONICA"],
                        iscatalogo: usuario[0]["CATALOGO"],
                        isestrutura: usuario[0]["ESTRUCTURACION"],
                        isventas: usuario[0]["VENTAS"],
                        ispedido: usuario[0]["PEDIDOS"],
                        isadmpedido: usuario[0]["ADMIN_PEDIDOS"],
                        ispos: usuario[0]["POS"],
                        isinventario: usuario[0]["INVENTARIO"],
                        activefacele: perm[0]["FACTURACION_ELECTRONICA"],
                        activecatalogo: perm[0]["CATALOGO"],
                        activeestrutura: perm[0]["ESTRUCTURACION"],
                        activeventas: perm[0]["VENTAS"],
                        activepedido: perm[0]["PEDIDOS"],
                        activeadmpedido: perm[0]["ADMIN_PEDIDOS"],
                        activeinventario: perm[0]["INVENTARIO"],
                        activepos: perm[0]["POS"],
                    })
                }
                this.setState({
                    vendedores: vend,
                    activefacele: perm[0]["FACTURACION_ELECTRONICA"],
                    activecatalogo: perm[0]["CATALOGO"],
                    activeestrutura: perm[0]["ESTRUCTURACION"],
                    activeventas: perm[0]["VENTAS"],
                    activepedido: perm[0]["PEDIDOS"],
                    activeadmpedido: perm[0]["ADMIN_PEDIDOS"],
                    activeinventario: perm[0]["INVENTARIO"],
                    activepos: perm[0]["POS"],
                    dinamyc_permit: permitsByCompany,
                })
            });

        this.setState({ titulo, id_usuario });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { codEmp, nombre, usuario, password, estado, tipo_usuario, vendedor_asociado, isfacele, iscatalogo, isestrutura, isventas, ispedido, isadmpedido, isinventario, ispos, empresa, dinamyc_permit } = this.state;
        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                codEmp,
                nombre,
                usuario,
                password,
                estado,
                tipo_usuario,
                vendedor_asociado,
                isfacele,
                iscatalogo,
                isestrutura,
                isventas,
                ispedido,
                isinventario,
                ispos,
                isadmpedido,
                dinamyc_permit
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_usuario === "") {
            ruta = config.servBackEnd + '/users/create'
        } else {
            ruta = config.servBackEnd + '/users/modify/' + this.state.id_usuario
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                ////console.log(data);
                if (data.ok) {
                    const nuevoUsuario = (data.data && data.data.insertId) ? data.data.insertId : this.state.id_usuario;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_usuario: nuevoUsuario });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Usuario con errores:" + errores[data.code] + " " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
        event.preventDefault();
    }

    CheckedPerm = ({ target }) => {
        const { id } = target;
        const { checked } = target;
        this.setState({ [id]: checked });
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    updateList = (modulo) => {
        const { dinamyc_permit } = this.state
        const moduleUpdate = dinamyc_permit.map((element) => {
            if (modulo.ID === element.ID_MODULO) element.ACTIVO = !element.ACTIVO
            return element
        })
        this.setState({ dinamyc_permit: [...moduleUpdate] });
    }

    render() {
        const mensajeBoton = (this.state.id_usuario === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_usuario === "") ? '¿Esta seguro que desea crear el usuario?' : '¿Esta seguro que desea modificar el usuario?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const { vendedores, dinamyc_permit } = this.state;
        const modulosPorGrupo = {};
        dinamyc_permit.forEach((modulo) => {
            if (!modulosPorGrupo[modulo.NOMBRE_GRUPO_MODULO]) {
                modulosPorGrupo[modulo.NOMBRE_GRUPO_MODULO] = [];
            }
            modulosPorGrupo[modulo.NOMBRE_GRUPO_MODULO].push({
                ID: modulo.ID_MODULO,
                ACTIVO: modulo.ACTIVO,
                NOMBRE_MODULO: modulo.NOMBRE_MODULO
            });
        });
        // console.log(this.state.activeadmpedido)
        return (
            <div className="FormularioUsuario">

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <TitleModule text={this.state.titulo} />
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <BackButton />
                        <Card bg={'light'}>
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Control type="hidden" value={this.state.id_usuario} required disabled />
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled={!(this.state.tipo === '0')} />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridNombre">
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control type="text" placeholder="Nombre" onChange={e => this.setState({ nombre: e.target.value.toUpperCase() })} value={this.state.nombre} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridUsuario">
                                            <Form.Label>Usuario</Form.Label>
                                            <Form.Control type="text" placeholder="Usuario" onChange={e => this.setState({ usuario: e.target.value })} value={this.state.usuario} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridCodigoPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control type="password" placeholder="Password" onChange={e => this.setState({ password: e.target.value })} value={this.state.password} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="exampleForm.SelectCustom">
                                            <Form.Label>Tipo Usuario</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ tipo_usuario: e.target.value, vendedor_asociado: "0" })} value={this.state.tipo_usuario} required>
                                                <option value="1">Administrador</option>
                                                <option value="2">Gestor</option>
                                                <option value="3">Vendedor</option>
                                                <option value="4">Gestor Aprobador</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="exampleForm.SelectCustom">
                                            <Form.Label>Vendedor Asociado</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ vendedor_asociado: e.target.value })} value={this.state.vendedor_asociado}>
                                                <option value="0">Call Center</option>
                                                {
                                                    vendedores.map((vendedor, i) => {
                                                        return (
                                                            <option key={i} value={vendedor.ID_VENDEDORES}>{vendedor.NOMBRE_VENDEDOR}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridEstado">
                                            <Form.Label>Estado</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required>
                                                <option value="0">Inactivo</option>
                                                <option value="1">Activo</option>
                                            </Form.Control>
                                        </Form.Group>

                                    </Form.Row>
                                    <h3>PERMISOS</h3>
                                    <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
                                        {/* Iterar sobre cada grupo */}
                                        {Object.keys(modulosPorGrupo).map((grupo) => (
                                            <div key={grupo} >
                                                <h3 style={{ marginBottom: '10px' }}>{grupo}</h3>
                                                {/* Iterar sobre los módulos dentro de cada grupo */}
                                                {modulosPorGrupo[grupo].map((modulo, index) => (
                                                    <div key={index} style={{ marginBottom: '5px', textAlign: 'left' }} onClick={() => this.updateList(modulo)} >
                                                        <Form.Check // prettier-ignore
                                                            type='checkbox'
                                                            name={modulo.ID}
                                                            checked={modulo.ACTIVO}
                                                            label={modulo.NOMBRE_MODULO}
                                                            readOnly
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioUsuario);








// WEBPACK FOOTER //
// ./src/components/configuracion/formularioUsuario.jsx